export default "__VITE_ASSET__nWj9hc5Z__"